import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "./resources";
import type { UiLanguage } from "../session/types";

const LANGUAGE_STORAGE_KEY = "ysi.web.ui-language";

export function readInitialLanguage(): UiLanguage {
  if (typeof window !== "undefined") {
    const saved = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (saved === "zh" || saved === "en") {
      return saved;
    }
    if (window.navigator.language.toLowerCase().startsWith("en")) {
      return "en";
    }
  }
  return "zh";
}

export function applyUiLanguage(language: UiLanguage): void {
  if (typeof document !== "undefined") {
    document.documentElement.lang = language === "zh" ? "zh-CN" : "en";
  }
  if (typeof window !== "undefined") {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  }
  void i18n.changeLanguage(language);
}

const initialLanguage = readInitialLanguage();

void i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: "zh",
  keySeparator: false,
  interpolation: { escapeValue: false },
  returnNull: false
});

applyUiLanguage(initialLanguage);

export default i18n;
